// El tope de presupuesto tecleado en pesos: vacío es sin tope; si no, un monto mayor a $0.
// Acepta comas de miles bien agrupadas («1,500») y hasta dos decimales.
const PLAIN = /^\d+(\.\d{1,2})?$/;
const GROUPED = /^\d{1,3}(,\d{3})+(\.\d{1,2})?$/;

export const BUDGET_AMOUNT_MESSAGE = 'Pon un monto mayor a $0 con hasta dos decimales.';

export type BudgetAmount = { ok: true; cents: number | null } | { ok: false };

export function parseBudgetAmount(text: string): BudgetAmount {
    const trimmed = text.trim();
    if (trimmed === '') return { ok: true, cents: null };
    if (!PLAIN.test(trimmed) && !GROUPED.test(trimmed)) return { ok: false };
    const pesos = Number(trimmed.replaceAll(',', ''));
    if (!(pesos > 0)) return { ok: false };
    return { ok: true, cents: Math.round(pesos * 100) };
}
